import { productBrandStyles } from "@insite/content-library/Components/ProductBrand";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

Object.assign(productBrandStyles, {
    nameLink: {
        css: css`
            width: 100%;
            span {
                color: ${getProp("theme.typography.p.color")} !important;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                font-size: ${TYPOGRAPHY.size.large};
                line-height: 24px;
            }
        `,
    },
});
